import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiFetchImpcStockLevelsListAll = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getImpcStockLevelsListAll',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, payload.params);
};

export default apiFetchImpcStockLevelsListAll;
